/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';

import type {
  Props as DegreeCardProps,
  TrackingData,
} from 'bundles/unified-description-page-common/components/modules/credits/DegreeCard';
import DegreeCard from 'bundles/unified-description-page-common/components/modules/credits/DegreeCard';
import Modal from 'bundles/unified-description-page-common/components/shared/modals/Modal';
import type { ModalProps } from 'bundles/unified-description-page-common/components/shared/modals/Modal';

import _t from 'i18n!nls/enterprise-legacy-learner-home';

const styles = {
  withMarginBottom: css`
    margin-bottom: var(--cds-spacing-300);
  `,
  withMarginTop: css`
    margin-top: var(--cds-spacing-300);
  `,
};

export type Props = ModalProps & {
  degrees: DegreeCardProps['degree'][];
  trackingData: Omit<TrackingData, 'index'>;
  description?: React.ReactNode;
  disclaimer?: string;
  title?: string;
  openInNewTab?: boolean;
  disableCta?: boolean;
};

const DegreesModal = ({
  description,
  disclaimer,
  degrees,
  title,
  openInNewTab,
  disableCta,
  trackingData,
  ...modalProps
}: Props) => {
  return (
    <Modal
      {...modalProps}
      header={title ?? _t('Get a head start on your degree')}
      width="large"
      closeModalTrackingName="close_degrees_modal"
      primaryButtonTrackingName="primary_button_degrees_modal"
    >
      {description && <div css={styles.withMarginBottom}>{description}</div>}
      <Grid container spacing={16}>
        {degrees.map((degree, index) => {
          return (
            <Grid item xs={12} md={6} key={degree.id}>
              <DegreeCard
                degree={degree}
                openInNewTab={openInNewTab}
                disableCta={disableCta}
                trackingData={{ index, ...trackingData }}
                isModalOpen={modalProps.open}
              />
            </Grid>
          );
        })}
        {disclaimer && (
          <Typography2 component="p" css={styles.withMarginTop} variant="bodySecondary">
            {disclaimer}
          </Typography2>
        )}
      </Grid>
    </Modal>
  );
};

export default DegreesModal;
